import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, BarChart, Bar, LabelList, Cell } from 'recharts';
import { TrendingUp, BarChart3 } from 'lucide-react';

export function TrendPanel({ data = [] }) {
  return (
    <div className="panel p-4 flex flex-col" style={{ minHeight: 260 }}>
      <div className="panel-header">
        <div className="flex items-center gap-2">
          <div className="icon-chip" style={{ background: 'rgba(59,130,246,0.14)', color: '#60A5FA', border: '1px solid rgba(59,130,246,0.25)', width: 28, height: 28 }}>
            <TrendingUp size={14} />
          </div>
          <div>
            <div className="panel-title">اتجاه البلاغات</div>
            <div className="panel-subtitle mt-0.5">آخر 7 أيام</div>
          </div>
        </div>
      </div>
      <div style={{ height: 190 }}>
        {data.length === 0 ? (
          <div className="h-full flex items-center justify-center text-slate-500 text-sm">لا توجد بيانات</div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 10, right: 10, bottom: 5, left: 0 }}>
              <defs>
                <linearGradient id="trendLine" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#60A5FA" />
                  <stop offset="100%" stopColor="#3B82F6" />
                </linearGradient>
              </defs>
              <CartesianGrid stroke="rgba(255,255,255,0.08)" strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="day" tick={{ fill: '#94A3B8', fontSize: 10.5 }} axisLine={false} tickLine={false} reversed />
              <YAxis tick={{ fill: '#94A3B8', fontSize: 10.5 }} axisLine={false} tickLine={false} orientation="right" allowDecimals={false} width={30} />
              <Tooltip contentStyle={{ background: '#141922', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, fontSize: 12, boxShadow: '0 12px 30px -12px rgba(0,0,0,0.6)', color: '#F5F7FA' }} cursor={{ stroke: 'rgba(255,255,255,0.08)' }} />
              <Line type="monotone" dataKey="value" stroke="url(#trendLine)" strokeWidth={2.5}
                dot={{ r: 4, fill: '#3B82F6', stroke: '#141922', strokeWidth: 2 }}
                activeDot={{ r: 6, stroke: '#93C5FD', strokeWidth: 2, fill: '#3B82F6' }} />
            </LineChart>
          </ResponsiveContainer>
        )}
      </div>
      <div className="flex items-center justify-center gap-2 text-[11px] text-slate-400 mt-1">
        <span className="w-3 h-0.5 bg-blue-500 inline-block rounded-full"></span> عدد البلاغات اليومي
      </div>
    </div>
  );
}

export function ProvinceBars({ data = [] }) {
  return (
    <div className="panel p-4 flex flex-col" style={{ minHeight: 260 }}>
      <div className="panel-header">
        <div className="flex items-center gap-2">
          <div className="icon-chip" style={{ background: 'rgba(245,158,11,0.14)', color: '#F59E0B', border: '1px solid rgba(245,158,11,0.25)', width: 28, height: 28 }}>
            <BarChart3 size={14} />
          </div>
          <div>
            <div className="panel-title">حسب المحافظات</div>
            <div className="panel-subtitle mt-0.5">توزيع البلاغات</div>
          </div>
        </div>
      </div>
      <div style={{ height: 200 }}>
        {data.length === 0 ? (
          <div className="h-full flex items-center justify-center text-slate-500 text-sm">لا توجد بيانات</div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 24, right: 5, left: 0, bottom: 5 }}>
              <defs>
                <linearGradient id="barFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#60A5FA" />
                  <stop offset="100%" stopColor="#3B82F6" />
                </linearGradient>
              </defs>
              <CartesianGrid stroke="rgba(255,255,255,0.08)" strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="name" tick={{ fill: '#94A3B8', fontSize: 10.5 }} axisLine={false} tickLine={false} reversed />
              <YAxis tick={{ fill: '#94A3B8', fontSize: 10.5 }} axisLine={false} tickLine={false} orientation="right" width={30} tickFormatter={(v) => v >= 1000 ? (v / 1000).toFixed(1).replace('.0', '') + 'K' : v} />
              <Tooltip contentStyle={{ background: '#141922', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, fontSize: 12, boxShadow: '0 12px 30px -12px rgba(0,0,0,0.6)', color: '#F5F7FA' }} cursor={{ fill: 'rgba(139,92,246,0.08)' }} />
              <Bar dataKey="value" radius={[6, 6, 0, 0]} maxBarSize={34}>
                {data.map((_, i) => <Cell key={i} fill="url(#barFill)" />)}
                <LabelList dataKey="value" position="top" style={{ fill: '#CBD5E1', fontSize: 10.5, fontWeight: 700 }} formatter={(v) => v.toLocaleString('en-US')} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
